import React, { FC, ReactElement, useEffect, useState } from 'react';
import { Card, Grid, Paper } from '@mui/material';
import { AppContext } from '../../context/AppContext';
import BakeasyEmptyMsg from '../../components/common/BakeasyEmptyMsg';
import BakeasyHeaderLabel from '../../components/lables/BakeasyHeaderLabel';
import BakeasyTable from '../../components/tables/BakeasyTable';
import {
  BakeasyChip,
  BakeasyChipEdit,
  BakeasyChipRead,
  BakeasyChipSent,
} from '../../components/common/BakeasyChip';
import { useLocation, useNavigate } from 'react-router-dom';
import { t } from 'i18next';
import '../../styles/styles.css';
import { useAppDispatch, useAppSelector } from '../../redux_store/reduxStore';
import {
  addProductToStores,
  clearProductState,
  deactivateProduct,
  downloadProducts,
  fetchProducts,
  productsState,
  reactivateProduct,
  unavailableProduct,
} from '../../redux_store/slices/productsSlice';
import { authActions } from '../../redux_store/slices/authSlice';
import { UNAUTHORIZED } from '../../constants/Constants';
import {
  BakeasyButtonFilter,
  BakeasyButtonAdd,
  BakeasyButtonUpdate,
  BakeasyButtonStatus,
  BakeasyButtonExport,
  BakeasyButtonPrint,
} from '../../components/buttons/BakeasyButton';
import * as TextField from '../../components/textfields/BakeasyTextFields';
import { BakeasyAppBar } from '../../components/common/BakeasyAppBar';
import { clearCategoryState } from '../../redux_store/slices/categorySlice';
import { clearSubCategoryState } from '../../redux_store/slices/subCategorySlice';
import { showErrorSnackbar } from '../../redux_store/slices/snackbarSlice';
import { productTableHeaders } from '../../constants/TableHeaders';
import BakeasySelectedFilters from '../../components/common/BakeasySelectedFilters';
import { deleteKeyFromObject, preparePayload } from '../../utils/commonUtils';
import { useDebouncedFetch } from '../../custom/useDebouncedCallback';

export const Products: FC = (): ReactElement => {
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const fetchData = useDebouncedFetch();

  const tableRef = React.useRef<any>();

  let myContext = React.useContext(AppContext);
  const [productList, setProductList] = useState<any[]>([]);
  const [search, setSearch] = useState<string>('');
  const [count, setCount] = React.useState<number>(0);
  const [selectedRows, setSelectedRows] = React.useState<any>([]);
  const [tFilter, setTFilter] = React.useState<any>({});

  let { error, value, rowsPerPage, pageNo, filter } =
    useAppSelector(productsState);

  const refreshPageData = async (
    newPage: number,
    search?: string,
    filter?: {} | undefined
  ) => {
    let payload = await preparePayload(
      { limit: rowsPerPage, page: newPage + 1 },
      filter,
      search,
      newPage
    );

    if (
      location?.state?.categoryId !== '' &&
      location?.state?.categoryId !== undefined
    ) {
      payload = { ...payload, categoryId: location?.state?.categoryId };
    }

    if (
      location?.state?.subCategoryId !== '' &&
      location?.state?.subCategoryId !== undefined
    ) {
      payload = { ...payload, subCategoryId: location?.state?.subCategoryId };
    }

    await dispatch(fetchProducts(payload));
    // await fetchData(fetchProducts, payload);
  };

  // useEffect(() => {
  //   return () => fetchData.cancel(); // Cancel debounce on component unmount to avoid memory leaks
  // }, [fetchData]);

  useEffect(() => {
    if (error === UNAUTHORIZED) {
      dispatch(authActions.logout());
    }
  }, [error]);

  function openProductAssignConfirmDialog(payload: any) {
    myContext.setConfirmDialog({
      type: 'assign',
      open: true,
      title: t('ASSIGN_PRODUCT'),
      message: t('ASSIGN_PRODUCT_MESSAGE'),
      onYesClick: async (event: any, param: string | undefined) => {
        await dispatch(addProductToStores(payload));
        await refreshPageData(pageNo - 1);
      },
    });
  }

  function openProductUnassignConfirmDialog(payload: any) {
    myContext.setConfirmDialog({
      type: 'unassign',
      open: true,
      title: t('UNASSIGN_PRODUCT'),
      message: t('ASSIGN_PRODUCT_MESSAGE'),
      onYesClick: async (event: any, param: string | undefined) => {
        await dispatch(addProductToStores(payload));
        await refreshPageData(pageNo - 1);
      },
    });
  }

  useEffect(() => {
    if (value?.totalCount === -1) {
      refreshPageData(pageNo);
    } else {
      const filteredData: any = value?.data?.map((product: any) => {
        return {
          productChecked: false,
          _id: product?._id,
          productName: product.productName,
          onProductNameClick: () => {
            dispatch(clearCategoryState());
            dispatch(clearSubCategoryState());
            navigate('/createProduct', {
              state: { isView: true, isEdit: false, _id: product?._id },
            });
          },
          productID: product.userProductId,
          categoryName: product.categoryName ?? '',
          subCategoryName: product.subCategoryName ?? '',
          productType: product.productType,
          add: (
            <BakeasyButtonStatus
              label={
                product?.isAssignedToallStores
                  ? t('UNASSIGN_FROM_ALL_STORES')
                  : t('ADD_TO_ALL_STORES')
              }
              size="small"
              style={{
                backgroundColor: product?.isAssignedToallStores
                  ? '#e53935'
                  : '',
                color: product?.isAssignedToallStores ? 'white' : '',
                textTransform: 'none',
              }}
              onClick={function (
                event: React.MouseEvent<HTMLButtonElement, MouseEvent>
              ): void {
                const payload = {
                  product,
                  assignment: product?.isAssignedToallStores
                    ? 'unassign'
                    : 'assign',
                };

                if (product?.isAssignedToallStores) {
                  openProductUnassignConfirmDialog(payload);
                } else {
                  openProductAssignConfirmDialog(payload);
                }
              }}
            />
          ),

          // add: (
          //   <BakeasyButtonStatus
          //     label={'Add to all Stores'}
          //     size={'small'}
          //     onClick={function (event: React.MouseEvent<HTMLButtonElement, MouseEvent>): void {
          //       debugger
          //       openProductAddConfirmDialog({
          //         product,
          //         assignment: 'assign'
          //       });
          //     }}
          //   />
          // ),
          status: (
            <BakeasyButtonStatus
              label={
                product?.status === 'Active'
                  ? t('ACTIVE')
                  : product?.status === 'Inactive'
                    ? t('INACTIVE')
                    : t('UNAVAILABLE')
              }
              color={
                product?.status === 'Active'
                  ? 'success'
                  : product?.status === 'Inactive'
                    ? 'error'
                    : 'info'
              }
              size={'small'}
              onClick={function (
                event: React.MouseEvent<HTMLButtonElement, MouseEvent>
              ): void {
                openProductActivationConfirmDialog(product);
              }}
            />
          ),
          isReceipeBuilder: product.isReceipeBuilder ? (
            <BakeasyChip label="YES" />
          ) : (
            <BakeasyChip
              label="NO"
              tooltipTitle="To subscribe to Recipe Builder, please contact Bakeasy"
            />
          ),
          actions: [
            <BakeasyChipEdit
              key={product?._id}
              onClick={async (event: any) => {
                dispatch(clearCategoryState());
                dispatch(clearSubCategoryState());
                navigate('/createProduct', {
                  state: { isEdit: true, _id: product?._id },
                });
              }}
            />,
          ],
        };
      });

      setProductList(filteredData);
      setCount(value?.totalCount);
    }
  }, [value]);

  const handleUpdateStatusClick = () => {
    if (selectedRows.length === 0) {
      dispatch(
        showErrorSnackbar({ message: t('NO_PRODUCTS_SELECTED_ASSIGNMENT') })
      );
      return;
    }
    openProductActivationConfirmDialog();
  };

  function openProductActivationConfirmDialog(product?: any) {
    myContext.setConfirmDialog({
      type: 'productActivation',
      open: true,
      title: t('UPDATE_PRODUCT'),
      message: t('UPDATE_PRODUCT_MESSAGE'),
      onYesClick: async (event: any, param: string | undefined) => {
        let payload = {};
        if (product) {
          payload = { productIds: [product?._id] };
        } else {
          const productIds = selectedRows.map((row: any) => row._id);
          payload = { productIds };
        }

        if (param === 'Inactive') {
          await dispatch(deactivateProduct(payload));
        } else if (param === 'Active') {
          await dispatch(reactivateProduct(payload));
        } else if (param === 'Temp. Unavailable') {
          await dispatch(unavailableProduct(payload));
        }

        setSelectedRows([]);
        await refreshPageData(pageNo - 1);
      },
    });
  }

  const handleRowCheck = (rows: any, checked: boolean) => {
    if (checked) {
      setSelectedRows([...selectedRows, ...rows]);
    } else {
      const filterRows = selectedRows.filter(
        (tableRow: any) => !rows.some((row: any) => tableRow._id === row._id)
      );
      setSelectedRows([...filterRows]);
    }
  };

  function openFilterProductConfirmDialog() {
    myContext.setConfirmDialog({
      type: 'product-filter',
      open: true,
      title: t('PRODUCT_FILTER'),
      data: filter,
      onNoClick: (event: any) => {},
      onYesClick: async (event: any, param: any) => {
        setTFilter(param);
        refreshPageData(0, search, param);
      },
    });
  }

  const handleDelete = async (key: any) => {
    let newFilters = await deleteKeyFromObject(key, tFilter);
    setTFilter(newFilters);
    refreshPageData(pageNo - 1, search, newFilters);
  };

  function productsUI() {
    return (
      <Grid>
        {location?.state?.subCategoryId !== '' &&
          location?.state?.subCategoryId !== undefined &&
          location?.state?.categoryId !== '' &&
          location?.state?.categoryId !== undefined && (
            <Grid item>
              <BakeasyAppBar
                title={t('PRODUCTS')}
                onBackClick={() => {
                  navigate(-1);
                }}
              />
            </Grid>
          )}

        <Paper component={Card} variant="outlined" sx={{ p: 2, mt: 1 }}>
          {(location?.state?.subCategoryId === '' ||
            location?.state?.subCategoryId === undefined ||
            location?.state?.categoryId === '' ||
            location?.state?.categoryId === undefined) && (
            <BakeasyHeaderLabel message={t('PRODUCTS')} />
          )}

          <Grid
            container
            spacing={2}
            sx={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
            }}
          >
            <Grid item xs={12} sm={12} md={12} lg={2} xl={2}>
              <TextField.Search
                value={search}
                onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                  setSearch(event?.target?.value);
                  if (
                    event?.target?.value?.length === 0 ||
                    event?.target?.value?.length > 2
                  ) {
                    refreshPageData(
                      pageNo - 1,
                      event?.target?.value?.length === 0
                        ? undefined
                        : event?.target?.value,
                      filter
                    );
                  }
                }}
                onIconClick={(
                  event: React.MouseEvent<HTMLButtonElement, MouseEvent>
                ) => {
                  refreshPageData(pageNo - 1, search, filter);
                }}
                onEnterClick={(
                  event: React.KeyboardEvent<HTMLInputElement>
                ) => {
                  refreshPageData(pageNo - 1, search, filter);
                }}
              />
            </Grid>

            <Grid item xs={12} sm={12} md={12} lg={10} xl={10}>
              <div className="tableOptions">
                <BakeasyButtonPrint
                  onClick={function (
                    event: React.MouseEvent<HTMLButtonElement, MouseEvent>
                  ): void {
                    dispatch(
                      downloadProducts({ ...filter, downloadType: 'pdf' })
                    );
                  }}
                />

                <BakeasyButtonExport
                  onClick={function (
                    event: React.MouseEvent<HTMLButtonElement, MouseEvent>
                  ): void {
                    dispatch(
                      downloadProducts({ ...filter, downloadType: 'csv' })
                    );
                  }}
                />

                <BakeasyButtonFilter
                  onClick={function (
                    event: React.MouseEvent<HTMLButtonElement, MouseEvent>
                  ): void {
                    openFilterProductConfirmDialog();
                  }}
                />
                <BakeasyButtonUpdate
                  onClick={function (
                    event: React.MouseEvent<HTMLButtonElement, MouseEvent>
                  ): void {
                    handleUpdateStatusClick();
                  }}
                />

                <BakeasyButtonAdd
                  onClick={(event: React.MouseEvent<HTMLButtonElement>) => {
                    dispatch(clearCategoryState());
                    dispatch(clearSubCategoryState());
                    dispatch(clearProductState());
                    navigate('/createProduct', {
                      state: { isNew: true, isEdit: false, isView: false },
                    });
                  }}
                />
              </div>
            </Grid>
          </Grid>

          <BakeasySelectedFilters filter={filter} onDelete={handleDelete} />

          <Grid>
            {productList?.length > 0 ? (
              <BakeasyTable
                ref={tableRef}
                pageNo={pageNo - 1}
                search={search}
                headers={productTableHeaders}
                tableData={productList}
                count={count}
                refreshPageData={refreshPageData}
                handleCheckChanged={handleRowCheck}
                filter={filter}
              />
            ) : (
              <BakeasyEmptyMsg message={t('NO_DATA_FOUND')} />
            )}
          </Grid>
        </Paper>
      </Grid>
    );
  }

  return productsUI();
};
